import { LogLevel } from "./log-level";

export interface ILogger {
    readonly isDebugEnabled: boolean;
    readonly isInfoEnabled: boolean;
    readonly isWarnEnabled: boolean;
    readonly isErrorEnabled: boolean;

    minimumLogLevel: LogLevel;

    debug(message: (() => string) | string): void;
    debugAsync(message: () => Promise<string>): Promise<void>;
    info(message: (() => string) | string): void;
    infoAsync(message: () => Promise<string>): Promise<void>;
    warn(message: (() => string) | string): void;
    warnAsync(message: () => Promise<string>): Promise<void>;
    error(message: (() => string) | string, error?: Error): void;
    errorAsync(message: () => Promise<string>, error?: Error): Promise<void>;
}
